import { BREAKPOINTS } from "../config/breakpoints";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import GantryLocate from "./GantryLocate";
import ModuleMap from "./ModuleMap";
import Accordian from "../Generic/Accordian";
import { Cross, Tickmark } from "../Generic/Symbols";
import Button from "../Generic/Button";
import Card from "../Generic/Card";
import IotService from "./Services/iotService";
import Loader from "../Generic/Loader";
import { CSSTransition } from "react-transition-group";
import close from "../Assets/Close.png";
import useQuery from "../util/hooks/useQuery";
import { bindActionCreators } from "redux";
import { setMachineID } from "../Landing/Actions";
import * as Actions from "./Actions";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { errorNotification, successNotification } from "../Generic/Notifications";
import { isEmpty } from "../util/util";
import Timestamp from "../Generic/Timestamp";
import Dropdown from "../Generic/Dropdown";
import { zIndex } from "../config/zIndex";

const Page = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	padding: 1.5rem 2rem 2rem 2rem;
	overflow-y: auto;
	overflow-x: hidden;
	@media (max-width: ${BREAKPOINTS.desktop}px) {
		padding: 1.5rem 2rem 2rem 2rem;
	}
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		padding: 1rem;
	}
`;

const PageHeading = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	height: max-content;
	gap: 1rem;
	flex-wrap: wrap;
	align-items: center;
`;

const Header = styled.div`
	display: flex;
	font-size: 26px;
	margin: 0 0 0 0.5rem;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		font-size: 20px;
	}
`;

const Overlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: ${zIndex.modalBackdrop};
`;

const Modal = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	height: max-content;
	max-height: 80vh;
	min-height: 30%;
	width: 70vw;
	max-width: calc(100vw - 3rem);
	padding: 0;
	border-radius: 10px;
	overflow: hidden;
	z-index: ${zIndex.modal};
	@media (max-width: ${BREAKPOINTS.desktop}px) {
		// Not a standard breakpoint change: callers may need a wider modal than
		// the default 70vw once a page (e.g. ModuleMap) requires it. Allow an
		// opt-in custom width via prop instead of shipping a one-off breakpoint.
		width: ${(props) => props.widthBefore1000};
	}
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		width: 95%;
	}
	@media (max-width: ${BREAKPOINTS.mobile}px) {
		width: 100%;
		height: 100%;
		border-radius: 0;
		overflow-y: auto;
		overflow-x: auto;
	}
`;

const ModalBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	box-sizing: border-box;
	padding: 1.5rem;
	min-height: 0;
	overflow-y: auto;
	overflow-x: hidden;
	@media (max-width: ${BREAKPOINTS.mobile}px) {
		padding: 1rem;
	}
`;

const SecondaryHeader = styled.div`
	width: 100%;
	font-size: 22px;
	font-weight: 600;
	text-align: left;
	margin: ${(props) => props.margin};
`;

const GroupContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: max-content;
	width: 100%;
	padding: 0;
	border-radius: 10px;
	background: #fff;
	margin: ${(props) => props.margin};
	gap: 1.5rem;
`;

const InfoContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: wrap;
	height: max-content;
	width: 100%;
	gap: 1rem;
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
`;

const InfoContent = styled.div`
	flex: 1;
	flex-basis: 21%;
	flex-grow: 1;
	flex-direction: column;
	gap: 0.5rem;
	min-width: 160px;
	@media (max-width: ${BREAKPOINTS.desktop}px) {
		flex-basis: 30%;
		min-width: 140px;
	}
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		flex-basis: 45%;
		min-width: 120px;
	}
	@media (max-width: ${BREAKPOINTS.mobile}px) {
		flex-basis: 100%;
	}
`;

const InfoHead = styled.span`
	color: rgba(0, 0, 0, 0.5);
	width: max-content;
`;

const InfoData = styled.span`
	margin: 0.3rem 0 0 0;
	font-weight: 600;
`;

const Functionalities = styled.div`
	display: flex;
	gap: 1rem;
	flex-wrap: wrap;
	width: max-content;
	height: max-content;
`;

const Div = styled.div`
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	position: ${(props) => props.position};
	width: ${(props) => props.width};
	display: flex;
	flex-direction: ${(props) => props.flexDirection};
	flex-wrap: ${(props) => props.flexWrap};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	gap: ${(props) => props.gap};
	overflow-y: ${(props) => props.overflowY};
	overflow-x: ${(props) => props.overflowX};
	height: ${(props) => props.height};
	max-height: ${(props) => props.maxHeight};
	min-height: ${(props) => props.minHeight};
	max-width: ${(props) => props.maxWidth};
	white-space: ${(props) => props.whiteSpace};
	border: ${(props) => props.border};
	border-radius: ${(props) => props.borderRadius};
	box-sizing: ${(props) => props.boxSizing};
	@media (max-width: ${BREAKPOINTS.desktop}px) {
		justify-content: ${(props) => props.jContentBefore1000};
	}
`;

const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	color: ${(props) => props.color};
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
`;

const Row = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	gap: ${(props) => props.gap};
	flex-wrap: wrap;
	min-width: 0;
	max-width: 100%;
`;

const List = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 1rem;
	background: #fff;
	height: max-content;
	gap: 1rem;
`;
const ListItem = styled.div`
	display: flex;
	pointer-events: ${(props) => props.pointerEvents};
	background: #fff;
	align-items: baseline;
	justify-content: none;
	list-style: none;
	flex-wrap: wrap;
	gap: 0.5rem 1rem;
	min-width: 0;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		align-items: center;
		gap: 0.5rem;
	}
`;

const CenteredContainer = styled.div`
	width: 100%;
	height: max-content;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: ${(props) => props.margin};
`;

const Module = styled(Card)`
	// Card provides the column flex layout, centered alignment, radius, shadow
	// and padding; we only add the tile-specific font-size, click cursor, faster
	// transition and its hover lift.
	font-size: clamp(12px, 1vw, 16px);
	transition: 100ms all linear;
	&:hover {
		cursor: pointer;
		box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 6px, rgba(0, 0, 0, 0.3) 0px 2px 4px;
	}
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		width: 100%;
		padding: 1.25rem;
	}
`;

const System = styled.div`
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 7rem;
	padding: 10px 0;
	border-radius: 10px;
	height: max-content;
	background: ${(props) => (props.isActive ? "rgba(45, 35, 66, 0.1)" : "")};
	color: ${(props) => (props.isActive ? "#000" : "")};
`;

const SystemRow = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	gap: 0.75rem;
	width: 100%;
	max-width: 100%;
	min-width: 0;
	box-sizing: border-box;
	padding: 1rem;
`;

const Modules = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	width: 100%;
	gap: 1.5rem;
	background: #fff;
	padding: 1.5rem;
	border-radius: 10px;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		width: 100%;
		justify-content: center;
		padding: 1rem;
		gap: 1rem;
	}
`;

const PrimaryText = styled.span`
	color: rgba(0, 0, 0, 1);
	font-size: 18px;
	font-weight: 600;
	margin: ${(props) => props.margin};
`;

const SecondaryText = styled.span`
	color: rgba(0, 0, 0, 0.5);
	font-size: 14px;
	font-weight: 400;
	margin: ${(props) => props.margin};
`;

const ActionButtons = styled.div`
	display: flex;
	margin-left: auto;
	width: max-content;
	gap: 1rem;
`;

const DoorStatusGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	gap: 1rem;
	width: 100%;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
		gap: 0.75rem;
	}
	@media (max-width: ${BREAKPOINTS.mobile}px) {
		grid-template-columns: 1fr 1fr;
		gap: 0.5rem;
	}
`;

const DoorStatusCard = styled(Card)`
	// Card supplies the white column card shell (radius, centered, padded);
	// this only adds the border + subtle shadow and the hover lift.
	border: 1px solid rgba(0, 0, 0, 0.1);
	box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px;
	transition: 0.2s all ease;
	&:hover {
		box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 6px;
	}
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		padding: 1rem;
	}
	@media (max-width: ${BREAKPOINTS.mobile}px) {
		padding: 0.85rem;
		gap: 0.35rem;
	}
`;

const StatusCard = styled(Card)`
	// Deviate from the base Card, which shrinks to 1rem / 0.5rem padding at
	// tablet / mobile. These status cards need a roomier padding than the tuned
	// Card default, so we override it here rather than inheriting the generic
	// responsive treatment. No !important needed: styled(Card) rules come after
	// the base at equal specificity, so cascade order resolves the override.
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		padding: 1.5rem;
		gap: 1.5rem;
	}
	@media (max-width: ${BREAKPOINTS.mobile}px) {
		padding: 1.25rem;
		gap: 1.25rem;
	}
`;

const DoorStatusLabel = styled.div`
	color: rgba(0, 0, 0, 0.6);
	font-size: 13px;
	font-weight: 500;
	text-align: center;
	white-space: nowrap;
	@media (max-width: ${BREAKPOINTS.mobile}px) {
		font-size: 11px;
	}
`;

const DoorStatusValue = styled.div`
	display: flex;
	align-items: center;
	gap: 0.25rem;
	font-weight: 600;
	font-size: 15px;
`;


const COMPONENTS = {
	KITCHEN_STATUS: "KITCHEN_STATUS",
	KITCHEN_EVENTS: "KITCHEN_EVENTS",
	KITCHEN_STATES: "KITCHEN_STATES",
	KITCHEN_MODULES: "KITCHEN_MODULES",
	KITCHEN_MODULES_HEADER: "KITCHEN_MODULES_HEADER",
	MODULE_DATA: "MODULE_DATA",
};

const COMPONENT_STATES = {
	LOADING: "LOADING",
	ERROR: "ERROR",
	OK: "OK",
};

const INITIAL_COMPONENT_STATES = {
	[COMPONENTS.KITCHEN_STATUS]: COMPONENT_STATES.LOADING,
	[COMPONENTS.KITCHEN_EVENTS]: COMPONENT_STATES.LOADING,
	[COMPONENTS.KITCHEN_STATES]: COMPONENT_STATES.LOADING,
	[COMPONENTS.KITCHEN_MODULES]: COMPONENT_STATES.LOADING,
	[COMPONENTS.KITCHEN_MODULES_HEADER]: COMPONENT_STATES.LOADING,
	[COMPONENTS.MODULE_DATA]: COMPONENT_STATES.LOADING,
};

const COMPONENT_POLLING_PERIODS = {
	[COMPONENTS.KITCHEN_EVENTS]: 10 * 1000,
	[COMPONENTS.KITCHEN_MODULES]: 10 * 1000,
	[COMPONENTS.MODULE_DATA]: 10 * 1000,
	DEFAULT: 10 * 1000,
};

const COMPONENT_POLLING_IDS = {
	[COMPONENTS.KITCHEN_EVENTS]: null,
	[COMPONENTS.KITCHEN_MODULES]: null,
	[COMPONENTS.MODULE_DATA]: null,
};

const KitchenModules = (props) => {
	const {
		machineID,
		kitchenId,
		machineStructure,
		moduleTypes,
		setMachineStructureData,
		kitchenEvents,
		setKitchenEvents,
		activeModuleTypeData,
		setActiveModuleTypeData,
		setActiveModuleType,
		activeModuleType,
		activeModule,
		activeModuleData,
		setActiveModule,
		setActiveModuleData,
		activeSystem,
		setActiveSystem,
		kitchenOnlineStatus,
		kitchenStatus,
		doorStatuses,
		temperatureInfo,
		kitchenStates
	} = props;

	const query = useQuery();
	const [componentStates, changeComponentStates] = useState(INITIAL_COMPONENT_STATES);
	const componentPollingIds = useRef(COMPONENT_POLLING_IDS);
	const navigate = useNavigate();

function handleQueryParams(pageQuery = query) {
		const module = query.get("module");
		const system = query.get("system");
		const moduleType = query.get("moduleType");
		if (module && system && moduleType) {
			setRequiredActiveFields(moduleType, module, system);
		}
	}

	function setRequiredActiveFields(moduleType, module, system) {
		setActiveModuleType(moduleType);
		setActiveModule(module);
		setActiveSystem(system);
	}

	function visualizeData(data) {
		switch (typeof data) {
			case "boolean":
				return <InfoData>{data ? <Tickmark width="25px" /> : <Cross width="25px" />}</InfoData>;

			case "string":
				return <InfoData>{data}</InfoData>;

			default:
				return <InfoData>{data}</InfoData>;
		}
	}

	function renderActiveModuleData(data, moduleId, activeSystem, componentState) {
		if (!moduleId) return;
		let renderData = [],
			moduleRenderData = [],
			moduleContent = [];

		switch (componentState) {
			case COMPONENT_STATES.ERROR:
				renderData.push(<CenteredContainer>Could not fetch module data</CenteredContainer>);
				break;

			case COMPONENT_STATES.LOADING:
				renderData.push(
					<CenteredContainer>
						<Loader />
					</CenteredContainer>
				);
				break;

			case COMPONENT_STATES.OK:
				if(isEmpty(data)) {
					renderData.push(<CenteredContainer>No Module data found</CenteredContainer>)
					break;
				}

				const { systems } = data;

				if(isEmpty(systems)) {
					renderData.push(<CenteredContainer>No systems found for this module</CenteredContainer>)
				}

				for (const system in systems) {
					const { events, functionalities, error } = systems[system];
					const isActive = system === activeSystem;
					const addToTheFront = error;
					if (isActive) {
						if (events.length) {
							for (const event of events) {
								const { eventName, eventValue, timeStamp } = event;
								moduleContent.push(
									<InfoContent>
										<InfoHead>
											{eventName}
											&nbsp;
											<Timestamp value={timeStamp} variant="tooltipOnly" />
										</InfoHead>
										{visualizeData(eventValue)}
									</InfoContent>
								);
							}
						} else {
							moduleContent.push(
								<CenteredContainer>
									<InfoHead>No events found for this system</InfoHead>
								</CenteredContainer>
							);
						}
					}

					// if (functionalities && functionalities?.length) {
					// 	moduleHeader.push(
					// 		<Functionalities>
					// 			{functionalities.map((functionality) => {
					// 				const { name, workFlowName } = functionality;
					// 				return (
					// 					<Button
					// 						active
					// 						onClick={() => sendWorkflowRequest({ workFlowName })}>
					// 						{name}
					// 					</Button>
					// 				);
					// 			})}
					// 		</Functionalities>
					// 	);
					// }

					const JSX = (
						<System onClick={() => setActiveSystem(system)} width="15rem" isActive={isActive}>
							{error ? <Cross width="25px" /> : <Tickmark width="25px" />}
							&nbsp; System {system}
						</System>
					);

					addToTheFront ? moduleRenderData.unshift(JSX) : moduleRenderData.push(JSX);
				}

				renderData.push(
					<>					<SystemRow>
							{moduleRenderData}
						</SystemRow>
						<Div
							className="no-scrollbar"
							padding="1rem"
							flexDirection="row"
							gap="0.5rem"
							flexWrap="wrap"
							width="100%"
							boxSizing="border-box"
							border="1px solid rgba(0,0,0,0.3)"
							minHeight="10rem"
							borderRadius="10px">
							{moduleContent}
						</Div>
					</>
				);

				break;

			default:
				break;
		}

		return renderData;
	}

	function renderActiveTab(tab, pageData, componentState) {
		let renderData = [];
		if (!tab) return;
		const activeModuleData = moduleTypes.find((moduleType) => moduleType.moduleTypeId === activeModuleType);
		switch (componentState) {
			case COMPONENT_STATES.LOADING:
				renderData.push(
					<CenteredContainer>
						<Loader />
					</CenteredContainer>
				);
				break;

			case COMPONENT_STATES.ERROR:
				renderData.push(
					<Card padding="1.5rem" gap="1rem" width="100%" margin="0 0">
						<CenteredContainer>Could not get data for Module Type {activeModuleData.moduleTypeName}</CenteredContainer>
					</Card>
				);
				break;

			case COMPONENT_STATES.OK:
				if(isEmpty(pageData)) {
					renderData.push(
						<Card padding="1.5rem" gap="1rem" width="100%" margin="0 0">
							<CenteredContainer>Could not get data for Module Type {activeModuleData.moduleTypeName}</CenteredContainer>
						</Card>
					);
					break;
				}
				const { requiresMap, requiresDiagram } = pageData;
				if (requiresMap) {
					renderData.push(
						<ModuleMap machineStructure={machineStructure} moduleData={activeModuleTypeData} setActiveModule={setActiveModule} />
					);
					break;
				}
				if (requiresDiagram) {
					renderData.push(
						<GantryLocate
							machineStructure={machineStructure}
							moduleData={activeModuleTypeData}
							moduleType={tab}
							getLatestData={getLatestModuleTypeData}
						/>
					);
				}

				let moduleData = [];

				for (const module in pageData) {
					const { error } = pageData[module];
					moduleData.push(
					<Module
						onClick={() => {
							setActiveModule(module);
						}}
						borderRadius="10px"
						padding="1rem 1.5rem"
						boxShadow="rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px"
						background="transparent"
						alignItems="center"
						jContent="center">
						{error ? <Cross width="25px" /> : <Tickmark width="25px" />}
						&nbsp; Module {module}
					</Module>
					);
				}
				renderData.push(<Modules>{moduleData}</Modules>);
				break;

			default:
				break;
		}

		return renderData;
	}

	function renderKitchenStatus(data, componentState) {
		let renderData = [];

		switch (componentState) {
			case COMPONENT_STATES.LOADING:
				renderData.push(<Loader />);
				break;

			case COMPONENT_STATES.ERROR:
				renderData.push(<CenteredContainer>Failed to load Kitchen Status</CenteredContainer>);
				break;

			case COMPONENT_STATES.OK:
				if(isEmpty(data)) {
					renderData.push(<CenteredContainer>No Kitchen Status to show</CenteredContainer>);
					break;
				}
				const { kitchenStatus, kitchenOnlineStatus, doorStatuses, temperatureInfo } = data;
				let temperatureInFahrenheit = "-";
				let temperatureInCelcius = "-";
				if(temperatureInfo?.isValid) {
					temperatureInFahrenheit = temperatureInfo.temperatureInFahrenheit ? `${temperatureInfo.temperatureInFahrenheit.toFixed(2)}°F` : "-";
					temperatureInCelcius = temperatureInfo.temperatureInCelcius ? `${temperatureInfo.temperatureInCelcius.toFixed(2)}°C` : "-";
				}
				
				renderData.push(
					<Row gap="1rem 2rem">
						<Row gap="1rem">
							<PrimaryText>isOnline </PrimaryText>-{kitchenOnlineStatus ? <Tickmark width="25px" /> : <Cross width="25px" />}
						</Row>
						<Row gap="1rem">
							<PrimaryText>Status</PrimaryText>-<PrimaryText>{kitchenStatus}</PrimaryText>
						</Row>
						<Button onClick={clearKitchen} >Clear Kitchen</Button>
						<Row gap="1rem">
							<PrimaryText>Temperature</PrimaryText>-<PrimaryText>{`${temperatureInFahrenheit} / ${temperatureInCelcius}`}</PrimaryText>
							{
								temperatureInfo?.timeStamp ?
								<Timestamp value={temperatureInfo.timeStamp} variant="tooltipOnly" /> : ""
							}
						</Row>
					</Row>
				);			const doorStatusEntries = [
				{ key: 'floor1', label: 'Floor 1 Door' },
				{ key: 'floor0', label: 'Floor 0 Door' },
				{ key: 'floor-1', label: 'Floor -1 Door' },
				{ key: 'facade', label: 'Facade Door' },
			];

			renderData.push(
				<DoorStatusGrid>
					{doorStatusEntries.map(({ key, label }) => (
						<DoorStatusCard
						key={key}
						borderRadius="10px"
						padding="1.25rem"
						gap="0.5rem"
						alignItems="center"
						jContent="center">
							<DoorStatusLabel>{label}</DoorStatusLabel>
							<DoorStatusValue>
								{doorStatuses?.[key]?.status ? <Tickmark width="22px" /> : <Cross width="22px" />}
							</DoorStatusValue>
							{doorStatuses?.[key]?.timeStamp ?
								<Timestamp value={doorStatuses[key].timeStamp} variant="tooltipOnly" /> : ""
							}
						</DoorStatusCard>
					))}
				</DoorStatusGrid>
			)
				break;

			default:
				break;
		}

		return (
			<StatusCard jContent="" alignItems="" padding="1.5rem" gap="2rem" width="100%">
				{renderData}
			</StatusCard>
		);
	}

	function renderKitchenEvents(data, componentState) {
		let renderData = [];

		switch (componentState) {
			case COMPONENT_STATES.LOADING:
				renderData.push(
					<CenteredContainer>
						<Loader />
					</CenteredContainer>
				);
				break;

			case COMPONENT_STATES.ERROR:
				renderData.push(<CenteredContainer>Failed to load Kitchen Events</CenteredContainer>);
				break;

			case COMPONENT_STATES.OK:

				if(isEmpty(data)) {
					renderData.push(<CenteredContainer>No Recent Kitchen Events Found</CenteredContainer>);
					break;
				}

				for (const systemEventKey in data) {
					const events = data[systemEventKey];
					if (events?.length) {
						let eventsList = [];

						function goToAffectedSystem(module, system, moduleType) {
							setRequiredActiveFields(moduleType, module, system);
						}

						for (const event of events) {
							let affectedItemsData = [];

							const { value, modules } = event;

							for (const affectedModule in modules) {
								const { systems, moduleType } = modules[affectedModule];
								for (const affectedSystem in systems) {
									const { timestamp } = systems[affectedSystem];
									affectedItemsData.push(
										<ListItem>
											<SecondaryText margin="0 30px 0 0"><Timestamp value={timestamp} /></SecondaryText>
											<PrimaryText margin="0 30px 0 0"> Module : {affectedModule} </PrimaryText>
											<PrimaryText margin="0 30px 0 0"> System : {affectedSystem} </PrimaryText>
											<Div gap="0.5rem" margin="0 0 0 auto">
												<Button
													height="34px"
													active
													onClick={() => goToAffectedSystem(affectedModule, affectedSystem, moduleType)}>
													Check
												</Button>
											</Div>
										</ListItem>
									);
								}
							}

							eventsList.push(
								<ListItem>
									<Accordian headerBackground={"rgba(176, 0, 32, 0.2)"} activeInitially header={value}>
										<List>{affectedItemsData}</List>
									</Accordian>
								</ListItem>
							);
						}

						renderData.push(
							<Accordian activeInitially header={systemEventKey}>
								<List>{eventsList}</List>
							</Accordian>
						);
					}
				}
				break;

			default:
				break;
		}

		return (
			<StatusCard padding="1.5rem" gap="1rem" width="100%">
				{renderData}
			</StatusCard>
		);
	}

	function renderKitchenStates(data, componentState) {
		let renderData = [];

		switch (componentState) {
			case COMPONENT_STATES.LOADING:
				renderData.push(<Loader />);
				break;

			case COMPONENT_STATES.ERROR:
				renderData.push(<CenteredContainer>Failed to load Kitchen States</CenteredContainer>);
				break;

			case COMPONENT_STATES.OK:
				if(isEmpty(data?.kitchenStates)) {
					renderData.push(<CenteredContainer>No Kitchen States to show</CenteredContainer>);
					break;
				}

				for(const state in data?.kitchenStates) {

					const stateData = data.kitchenStates[state];
					const value = String(stateData?.value);

					renderData.push(
						<Row gap="1rem">
							<Row gap="1rem">
								<PrimaryText>{state}</PrimaryText> 
								<span>-</span>
								<span>{value}</span>
							</Row>
							<Button onClick={() => resetKitchenState(stateData?.key, state)} >Reset</Button>
						</Row>
					);
				}

				break;

			default:
				break;

		}

		return (
			<StatusCard jContent="" alignItems="" padding="1.5rem" gap="2rem" width="100%">
				{renderData}
			</StatusCard>
		);
	}

	function poll(func, component) {
		if (componentPollingIds.current[component]) {
			return;
		}
		let pollingInterval = COMPONENT_POLLING_PERIODS[component];
		if (!pollingInterval) pollingInterval = COMPONENT_POLLING_PERIODS.DEFAULT;
		const intervalId = setInterval(func, pollingInterval);
		componentPollingIds.current[component] = intervalId;
	}

	function stopPolling(component) {
		if (!componentPollingIds.current[component]) return;
		clearInterval(componentPollingIds.current[component]);
		componentPollingIds.current[component] = null;
	}

	function cleanupPolling() {
		for (const component in componentPollingIds.current) {
			clearInterval(componentPollingIds.current[component]);
		}
	}

	async function getLatestKitchenEvents(handleLoading = false) {
		if (handleLoading) changeComponentStates((prev) => (
			{ ...prev, 
				[COMPONENTS.KITCHEN_EVENTS]: COMPONENT_STATES.LOADING,
				[COMPONENTS.KITCHEN_STATUS]: COMPONENT_STATES.LOADING,
				[COMPONENTS.KITCHEN_STATES]: COMPONENT_STATES.LOADING,
			}
		));

		const response = await IotService.getKitchenSystemEvents(kitchenId);
		const { data, error } = response;
		if (data) {
			setKitchenEvents(data);

			if (handleLoading)
				changeComponentStates((prev) => ({
					...prev,
					[COMPONENTS.KITCHEN_EVENTS]: COMPONENT_STATES.OK,
					[COMPONENTS.KITCHEN_STATUS]: COMPONENT_STATES.OK,
					[COMPONENTS.KITCHEN_STATES] : COMPONENT_STATES.OK,
				}));

			poll(() => {
				getLatestKitchenEvents(false);
			}, COMPONENTS.KITCHEN_EVENTS);
		}

		if (error) {
			errorNotification("Failed to load kitchen events");
			changeComponentStates((prev) => ({
				...prev,
				[COMPONENTS.KITCHEN_EVENTS]: COMPONENT_STATES.ERROR,
				[COMPONENTS.KITCHEN_STATUS]: COMPONENT_STATES.ERROR,
				[COMPONENTS.KITCHEN_STATES]: COMPONENT_STATES.ERROR,
			}));
			stopPolling(COMPONENTS.KITCHEN_EVENTS);
		}
	}

	async function getMachineStructureData() {
		const response = await IotService.getMachineStructure(kitchenId);
		const { data, error } = response;
		if (data) {
			setMachineStructureData(data);
			changeComponentStates((prev) => ({
				...prev,
				[COMPONENTS.KITCHEN_MODULES_HEADER]: COMPONENT_STATES.OK,
			}));
		}
		if (error) {
			errorNotification("Failed to load Machine Structure");
			changeComponentStates((prev) => {
				return {
					...prev,
					[COMPONENTS.KITCHEN_MODULES_HEADER]: COMPONENT_STATES.ERROR,
				};
			});
		}
	}

	async function getLatestModuleTypeData(moduleType, handleLoading = false) {
		if (handleLoading)
			changeComponentStates((prev) => {
				return { ...prev, [COMPONENTS.KITCHEN_MODULES]: COMPONENT_STATES.LOADING };
			});
		const response = await IotService.getModuleTypeWiseDetails(kitchenId, moduleType);
		const { data, error } = response;
		if (data) {
			setActiveModuleTypeData(data);

			if (handleLoading)
				changeComponentStates((prev) => {
					return { ...prev, [COMPONENTS.KITCHEN_MODULES]: COMPONENT_STATES.OK };
				});

			poll(() => {
				getLatestModuleTypeData(moduleType, false);
			}, COMPONENTS.KITCHEN_MODULES);
		}
		if (error) {
			errorNotification('Could not get Module Type Data');
			if (activeModuleData) setActiveModuleData({});
			changeComponentStates((prev) => {
				return { ...prev, [COMPONENTS.KITCHEN_MODULES]: COMPONENT_STATES.ERROR };
			});
			stopPolling(COMPONENTS.KITCHEN_MODULES);
		}
	}

	async function getModuleTelemetries(moduleId, handleLoading = false) {
		if (handleLoading)
			changeComponentStates((prev) => {
				return { ...prev, [COMPONENTS.MODULE_DATA]: COMPONENT_STATES.LOADING };
			});

		const response = await IotService.getModuleTelemetries(kitchenId, moduleId);
		const { data, error } = response;
		if (data) {
			setActiveModuleData(data);
			changeComponentStates((prev) => {
				return { ...prev, [COMPONENTS.MODULE_DATA]: COMPONENT_STATES.OK };
			});
			poll(() => { getModuleTelemetries(moduleId) }, COMPONENTS.MODULE_DATA);
		}
		if (error) {
			errorNotification('Could not get Module Telemetries');
			changeComponentStates((prev) => {
				return { ...prev, [COMPONENTS.MODULE_DATA]: COMPONENT_STATES.ERROR };
			});
			stopPolling(COMPONENTS.MODULE_DATA);
		}
	}

	async function clearKitchen() {
		const response = await IotService.clearKitchen(kitchenId);
		const { data, error } = response;
		if(data) {
			successNotification(`Kitchen ${kitchenId} resetted succesfully`);
			getLatestKitchenEvents(true);
		} 
		if(error) {
			errorNotification(`Something went wrong in resetting the kitchen ${kitchenId}`)
		}
	}

	async function resetKitchenState(key, stateName) {

		changeComponentStates((prev) => {
			return { ...prev, [COMPONENTS.KITCHEN_STATES]: COMPONENT_STATES.LOADING };
		});

		const response = await IotService.resetKitchenState(kitchenId, key);
		const { data, error } = response;
		if(data) {
			successNotification(`${stateName} state resetted succesfully`);
			getLatestKitchenEvents(true);
		} 
		if(error) {
			errorNotification(`Something went wrong in resetting the ${stateName} state for ${kitchenId}`)
			changeComponentStates((prev) => {
				return { ...prev, [COMPONENTS.KITCHEN_STATES]: COMPONENT_STATES.OK };
			});
		}
	}

	useEffect(() => {
		if (activeModule) getModuleTelemetries(activeModule, true);
		else stopPolling(COMPONENTS.MODULE_DATA);
	}, [activeModule]);

	useEffect(() => {
		if (activeModuleType) {
			stopPolling(COMPONENTS.KITCHEN_MODULES);
			getLatestModuleTypeData(activeModuleType, true);
		}
	}, [activeModuleType]);

	useEffect(() => {
		getLatestKitchenEvents(true);
		getMachineStructureData();
		handleQueryParams(query);
		return () => {
			cleanupPolling();
		};
	}, []);

	return (
		<Page>
			<PageHeading>
				<Header>Kitchen Status</Header>
				<Button onClick={() => {navigate(`/${machineID}/godMode`)}} margin="0 0 0 1rem" >God Mode</Button>
			</PageHeading>
			{renderKitchenStatus({ kitchenOnlineStatus, kitchenStatus, doorStatuses, temperatureInfo }, componentStates[COMPONENTS.KITCHEN_STATUS])}
			<Header>Kitchen States</Header>
			{renderKitchenStates({ kitchenStates }, componentStates[COMPONENTS.KITCHEN_STATES])}
			<Header>Kitchen Events</Header>
			{renderKitchenEvents(kitchenEvents, componentStates[COMPONENTS.KITCHEN_EVENTS])}
			<Header>Kitchen Modules</Header>
			<Div width="100%" maxWidth="300px">
				<Dropdown
					head="Select Module Type"
					value={activeModuleType}
					optionsList={moduleTypes?.map((type) => ({ head: type.moduleTypeName, value: type.moduleTypeId })) || []}
					onChange={setActiveModuleType}
					widthVal="100%"
				/>
			</Div>
			{renderActiveTab(activeModuleType, activeModuleTypeData, componentStates[COMPONENTS.KITCHEN_MODULES])}
			<CSSTransition in={!!activeModule} timeout={300} classNames={"module"} unmountOnExit>
				<Overlay>
					<Modal>
						<Div background="rgba(45, 35, 66, 0.8)" color="#fff" padding="1rem" jContent="space-between">
							<Span fontSize="1.4rem">Module {activeModule}</Span>
							<img
								style={{
									height: "1.5rem",
									filter: "invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
								}}
								src={close}
								alt="close"
								onClick={() => {
									setActiveModule(null);
									setActiveModuleData({});
								}}
							/>
						</Div>
						<ModalBody>
							{renderActiveModuleData(activeModuleData, activeModule, activeSystem, componentStates[COMPONENTS.MODULE_DATA])}
						</ModalBody>
					</Modal>
				</Overlay>
			</CSSTransition>
		</Page>
	);
};

const mapStatetoProps = (state) => {
	const { kitchen, landing } = state;
	return {
		machineID: landing.machineID,
		kitchenId: landing.kitchenId,
		...kitchen,
	};
};

const mapDispatchToProps = (dispatch) => ({
	...bindActionCreators(
		{
			setMachineID: setMachineID,
			...Actions,
		},
		dispatch
	),
});

export default connect(mapStatetoProps, mapDispatchToProps)(KitchenModules);
